/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CodePullRequestIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M23.113 4.131c.537.238.887.775.887 1.369v3h1c4.144 0 7.5 3.356 7.5 7.5v10.231A4.999 4.999 0 0 1 31 36a4.999 4.999 0 0 1-1.5-9.769V16c0-2.488-2.012-4.5-4.5-4.5h-1v3a1.496 1.496 0 0 1-2.5 1.113l-5-4.5a1.5 1.5 0 0 1 0-2.225l5-4.5a1.51 1.51 0 0 1 1.613-.257M11 9a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-.5 4.769V26.23A4.999 4.999 0 0 1 9 36a4.999 4.999 0 0 1-1.5-9.769V13.77A4.999 4.999 0 0 1 9 4a4.999 4.999 0 0 1 1.5 9.769M11 31a2 2 0 1 0-4 0 2 2 0 0 0 4 0m20 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>}
        </IconWrapper>);
}
